import React, {  useState } from 'react';
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard React components
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import Grid from "@mui/material/Grid";

import IconSearch from "@mui/icons-material/Search";
import IconAdd from "@mui/icons-material/Add";

import Swal from 'sweetalert2';

import ModalBusqueda from '../ModalBusqueda';
import Autorizador from 'Repository/Banca/Autorizador';

function AddAutorizador({cuenta_uuid, onAdd}) {

    const [customerSelected, setCustomerSelected] = useState();
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [uuidSelected, setUuidSelected] = useState('');
    const autorizadorx = new Autorizador();

    const showSearchPopup = (event)=>{
        event.preventDefault();
        setIsOpenModal(true);
    }

    const onHandleOpenForm = (event)=>{
        setIsOpenModal(false);
    }

    const handleOnSelectedItem = (uuid, nombre_completo)=>{
        setIsOpenModal(false);
        setUuidSelected(uuid);
        setCustomerSelected(nombre_completo)
    }

    const onAddItem = (event) =>{
        const params = {
            cuenta_uuid: cuenta_uuid,
            persona_uuid: uuidSelected
        } 
        
        autorizadorx.add(params).then((response)=>{
            
           if(response.status ==="ok"){
            Swal.fire({
                icon: 'success',
                title: 'Notificaciones',
                html: response.response.text,
                showConfirmButton: true,
                confirmButtonText: 'Aceptar'
              }).then((value)=>{
                setCustomerSelected('');
                setUuidSelected('');
                onAdd();
              })
           }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Notificaciones',
                    html: response.response.text,
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar'
                });
           }
            
        })
    }

    return(
       <>
            <ModalBusqueda isOpen={isOpenModal} title="Buscar Autorizador" additionalFilter={ {'cuenta_uuid': cuenta_uuid} }  onOpenForm={ (value)=>onHandleOpenForm(value) }
                    onSelectedItem = { (uuid, nombre_completo) => handleOnSelectedItem(uuid, nombre_completo) }/>
            <SoftBox   px={3} component="form" role="form">
                <Grid container spacing={2} >
                    <Grid item xs={6} md={7} xl={7}>
                        <SoftBox mb={1} lineHeight={0}>
                            <SoftTypography variant="caption" color="text">
                                Agregar usuarios a esta cuenta
                            </SoftTypography>
                        </SoftBox>
                        <SoftBox>
                            <input type={"text"} className={"ITextbox"} name={"personaSelected"} value={ customerSelected } maxLength={50}
                                   autoComplete={"on"} readOnly={true} />
                        </SoftBox>
                    </Grid>

                    <Grid item xs={3} md={2} xl={2}>
                        <SoftBox pt={3} >
                            <button className={"btn-alpha-info"} type={"button"} onClick={ showSearchPopup }>
                                <i className="fa-solid fa-magnifying-glass"></i> Buscar
                            </button>
                        </SoftBox>
                    </Grid>
                    {( uuidSelected &&
                        
                        <Grid item xs={3} md={3} xl={3}>
                            <SoftBox pt={3} >
                                <button className={"btn-alpha-success-2 pad-element"} type={"button"} onClick={ (event) => onAddItem(event) }  >
                                    <i className="fa-solid fa-circle-check"></i>  Agregar seleccionada
                                </button>
                            </SoftBox>
                        </Grid>
                    
                    )}
                    
                </Grid>
            </SoftBox>
            
       </>
    )
    
}

AddAutorizador.propTypes = {
    cuenta_uuid: PropTypes.string,
    onAdd: PropTypes.func,
  };

export default AddAutorizador;